import { render, staticRenderFns } from "./InputToggle.vue?vue&type=template&id=64d8894e&"
import script from "./InputToggle.vue?vue&type=script&lang=js&"
export * from "./InputToggle.vue?vue&type=script&lang=js&"
import style0 from "./InputToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports